// One field block of a bulk-edit form: the inputs stay disabled until the "ändern" checkbox is
// ticked. Disabled inputs are not submitted, so an untouched field cannot reach the server at
// all — the server still trusts only its own apply[] list, this is the visible half of that rule.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "input", "body"]

  connect() {
    this.apply()
  }

  toggle() {
    this.apply()
  }

  apply() {
    const enabled = this.hasToggleTarget && this.toggleTarget.checked

    this.inputTargets.forEach((input) => {
      input.disabled = !enabled
      // SlimSelect keeps its own state and ignores writes to the native element, so the wrapping
      // select controller has to be told; see select_controller.js.
      const slim = this.application.getControllerForElementAndIdentifier(
        input,
        "select",
      )?.slimselect
      if (slim) enabled ? slim.enable() : slim.disable()
    })

    this.bodyTargets.forEach((body) => {
      body.classList.toggle("opacity-50", !enabled)
      body.classList.toggle("pointer-events-none", !enabled)
    })
  }
}
